import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';

@customElement('voy-toggle-button')
export class VoyToggleButton extends LitElement
{
    @property({type: String}) label: string = "";
    @property({type: Boolean}) checked: boolean = false;
    @property({type: Boolean}) disabled: boolean = false;

    static get styles()
    {
        return [
            css`
            .container {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            input {
                cursor: pointer;
                position: relative;
                -webkit-appearance: none;
                width: 32px;
                height: 16px;
                border-radius: 16px;
                background-color: var(--neutrals-grey-06, grey);
                padding: 0;
                margin: 0;
                outline: none;
            }

            input::after {
                content: "";
                position: absolute;
                height: 8px;
                width: 8px;
                top: 4px;
                left: 4px;
                border-radius: 50%;
                background-color: var(--neutrals-grey-10, white);
                transition: .4s;
            }

            input:focus {
                background-color: var(--neutrals-grey-05, grey);
            }

            input:hover,input:focus {
                box-shadow: 1px 2px 8px rgba(var(--neutrals-grey-06-rgb), 0.6);
            }

            input:checked {
                background-color: var(--primary-blue-05, blue);
            }

            input:checked:focus {
                background-color: var(--primary-blue-04, blue);
            }

            input:checked::after {
                left: 20px;
            }

            input:disabled {
                cursor: not-allowed;
                box-shadow: none;
                opacity: 0.5;
            }

            label {
                cursor: pointer;
                color: var(--neutrals-grey-02, black);
                font-family: MaerskText;
                font-size: 14px;
                padding-right: 10px;
            }
            `
        ];
    }

    render()
    {
        return html`
        <div class="container">
            ${this.label ? html`
            <label for="input">${this.label}</label>
            ` : html``}
            <input id="input" type="checkbox" .checked=${this.checked} .disabled=${this.disabled}
                   @input=${ (evt: InputEvent) => this.checked = (<HTMLInputElement>evt.target!).checked }>
        </div>
        `;
    }
};
